import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  exportLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  allCountryList: null,
  countryList: [],
  contestTypeList: [],
  companyList: [],
  exportData: [],
  featuredImage: {},
  featuredImage2: {},
  contestForEdit: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const AddContestSlice1 = createSlice({
  name: "addContests1",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    endCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    CompanyList: (state, action) => {
      const { companyList } = action.payload;
    //   console.log("jdsjsbfdsfsdfds", companyList);
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyList = companyList;
    },
    CompanyDropdownList: (state, action) => {
      const { companyDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.companyDropdownList = companyDropdownList;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },

    singleCompanyFetched: (state, action) => {
      state.actionsLoading = false;
      state.singleCompanyFetched = action.payload.singleCompanyFetched;
      state.error = null;
    },
  },
});
